import React from 'react';
import ReactDOM from 'react-dom';
import { AppContainer } from './components/AppContainer';

ReactDOM.render(<AppContainer />, document.getElementById('root'));
